import axios from '@/utils/AxiosConfig';

export default {
  async sectors() {
    return axios.api.get('/businesses/sectors');
  },
  async category(category) {
    return axios.api.get(`/businesses/categories/${category}`);
  },
  async categories() {
    return axios.api.get('/businesses/categories');
  },
  async categoriesBySector(sector) {
    return axios.api.get(`/businesses/sectors/${sector}/categories`);
  },
  async regions() {
    return axios.api.get('/businesses/regions');
  },
  async cities() {
    return axios.api.get('/businesses/cities');
  },
  async citiesByRegion(region) {
    return axios.api.get(`/businesses/regions/${region}/cities`);
  },
  search: async (query) => axios.api.get(`businesses/search?${query}`),
  toggleFollowing: async (payload) => axios.api.post(`/contributors/toggle-follow`, payload),
  constructSector: (sector) => ({
    ...sector,
    current: false,
    type: 'Sector',
  }),
  constructCategory: (category) => ({
    ...category,
  }),
  constructRegion: (region) => ({
    ...region,
  }),
  constructCity: (city) => ({
    ...city,
  }),
  convertRatingToBooleanArray(rating = 0)
  {
      return Array.from({ length: 5 }, (_, index) => index < rating);
  }
};
